import {
  endOfHighlightMark,
  highlightDiffsInClusters,
  startOfHighlightMark,
} from '@neptune/shared/common-util';

export function highlightAttributeSearchLabels(names: string[]): string[] {
  if (names.length !== 1) {
    return highlightDiffsInClusters(names);
  }

  return [`${startOfHighlightMark}${names[0]}${endOfHighlightMark}`];
}
